import {IMuWidget} from "./IMuWidget";
import {SavedFiltersCL} from "./generated/SavedFiltersCL";
import {UiFlashMessage} from "./UiFlashMessage";
import {DelayedSingleLauncher} from "../DelayedSingleLauncher";

export class UiSavedFiltersAdmin extends IMuWidget
{
	public clUrl: string;
	public showLinkTemplate: string;
	public places: Record<string, string>;
	private cl: SavedFiltersCL;
	private tree: any;
	private selectedNode: TreeNode|null;
	private targetNode: TreeNode|null;
	private saveOrdersDC: DelayedSingleLauncher;

	beforeIndex() {
		this.container.classList.add('row', 'saved-filter-admin');
		this.container.innerHTML = `<div class="col-md-6 saved-filter-admin__tree-container">
			<div mu-id="tree"></div>
		</div>
		<div class="col-md-6 saved-filter-admin__commands">
			<div class="jumbotron">
				Vybraná položka <strong mu-id="lSource"></strong><br />
				<span mu-id="pTarget">, cílová položka <strong mu-id="lTarget"></strong>.</span> 
			</div>

			<div mu-id="cButtons" class="buttons">
				<button class="btn btn-primary" mu-id="bEdit">Otevřít</button>
				<button class="btn btn-primary" mu-id="bCopy">Kopírovat</button>
				<button class="btn btn-primary" mu-id="bLink">Klonovat</button>
				<button class="btn btn-primary" mu-id="bMove">Přesunout</button>
				<button class="btn btn-danger" mu-id="bRemove">Odstrant</button>			
			</div>
			
			<div mu-id="pAddFolder" class="input-group">
				<input type="text" mu-id="cNewFolderName" class="form-control">
				<div class="input-group-btn">
					<button class="btn btn-primary" mu-id="bAddFolder">Přidat složku</button>
				</div>
			</div>
				
			<div mu-id="pRename" class="input-group">
				<input type="text" mu-id="cNewName" class="form-control">
				<div class="input-group-btn">
					<button class="btn btn-primary" mu-id="bRename">Přejmenovat</button>
				</div>
			</div>
			
			<div mu-id="pFolderPlace" class="input-group">
				<select class="form-control" mu-id="cPlace" mu-bind="places:@options"></select>
				<div class="input-group-btn">
					<button class="btn btn-primary" mu-id="bSetPlace">Nastavit umístění</button>
				</div>
			</div>			
		</div>`;
	}

	afterIndex() {
		this.cl = new SavedFiltersCL(this.clUrl);
		this.updateButtons();
		this.loadTree();
		this.saveOrdersDC = new DelayedSingleLauncher(
			3,
			() => this.doSaveOders()
		);
		this.muBindData({ places: this.places });
	}

	protected lastReorder: Date = null;

	async loadTree() {
		const expandedKeys = this.getAllTreeNodes().filter(n => n.expanded).map(n => n.key);
		const data = await this.cl.getMySavedFilters();
		const pe = this.ui.tree.parentElement;
		this.ui.tree.remove();
		const de =
		this.ui.tree = document.createElement('div')
		pe.appendChild(this.ui.tree);
		this.tree = $(this.ui.tree).fancytree({
			source: data,
			extensions: ['dnd'],
			activate: (event, data) => {
				this.selectedNode = data.node;
				this.targetNode = null;
				console.log(event);
				this.updateButtons();
				/* if( data.node.isFolder() ){
					data.node.toggleExpanded();
				} */
				// document.location = this.showLinkTemplate.replace('{id}', data.node.key.split('_')[1]);
			},
			renderNode: (ev, data) => {
				if (!data.node.data.isMy) data.node.span.classList.add('em')
			},
			dnd: {
				autoExpandMS: 400,
				focusOnClick: true,
				preventVoidMoves: true, // Prevent dropping nodes 'before self', etc.
				preventRecursiveMoves: true, // Prevent dropping nodes on own descendants
				dragStart: (node: TreeNode, data) => {
					this.lastReorder = new Date();
					return node.data.isMy || node.data.type == "filter";
				},
				dragEnter: (node: TreeNode, data) => {
					console.log([data.hitMode, node.data.isMy, node.data.type]);
					this.lastReorder = new Date();
					if (data.hitMode == "over")
						return node.data.isMy && node.data.type == "folder";
					else
						return true;
				},
				dragDrop: (node: TreeNode, data) =>
				{
					console.log([node, data]);
					const isReorder = data.hitMode != 'over' && node.parent.key == data.otherNode.parent.key;
					this.lastReorder = new Date();

					if (isReorder) {
						// jen změna pořadí
						this.targetNode = null;
						this.selectedNode = null;
						if (data.otherNode.data.isMy) {
							this.saveOrders();
							data.otherNode.moveTo(node, data.hitMode);
							return true;
						} else {
							return false;
						}
					} else {
						const target = data.hitMode == 'over'
							? node
							: node.parent;
						if (data.otherNode.data.type === 'folder') {
							this.cl.moveFolder(
								data.otherNode.data.id, target.data.id
							).then(() => this.loadTree());
						} else {
							this.targetNode = target;
							this.selectedNode = data.otherNode;
						}
					}
					this.updateButtons();
					return true;
				}
			},
		}).fancytree('getTree');
		this.selectedNode = null;
		this.targetNode = null;
		this.updateButtons();
		setTimeout(() => {
			for(let n of this.getAllTreeNodes())
				if (expandedKeys.includes(n.key)) n.setExpanded(true);
		}, 50);
		// this.tree.setOption("source", data);
		// this.tree.clear();
		// this.tree.getRootNode().addChildren(data);
		// this.ui.tree.innerHTML = "";
		// this.ui.tree.className = "";
	}

	private updateButtons() {
		if (this.targetNode && !this.targetNode.data.isMy && !this.targetNode.key.startsWith('root_')) {
			this.targetNode = null;
		}

		this.ui.lSource.innerText = this.selectedNode ? this.selectedNode.title : "nevybrán";
		if (this.targetNode) this.ui.lTarget.innerText = this.targetNode.key.startsWith('root_')
			? 'Nejvyšší úrověň'
			: this.targetNode.title;
		this.muVisible(!!this.targetNode, 'pTarget');
		this.muVisible(false, ['bEdit', 'bCopy', 'bLink', 'bMove', 'pAddFolder', 'bRemove', 'pRename', 'pFolderPlace']);

		if (this.targetNode) {
			// presun, kopie, link
			this.muVisible(this.selectedNode.data.isMy, 'bMove');
			this.muVisible(true, ['bCopy', 'bLink']);
		} else {
			// jeden vybraný
			if (this.selectedNode) {
				this.muVisible(this.selectedNode.data.type != 'folder', 'bEdit');
				this.muVisible(this.selectedNode.data.isMy, 'bRemove');
				if (this.selectedNode.data.isMy && this.selectedNode.data.type == 'folder') {
					this.muVisible(true, 'pFolderPlace');
					this.ui.cPlace.value = this.selectedNode.data.place;
				}
			}
			this.ui.cNewName.value = this.selectedNode ? this.selectedNode.title : '';
			this.muVisible(!this.selectedNode || this.selectedNode.data.isMy, 'pAddFolder');
			this.muVisible(this.selectedNode && this.selectedNode.data.isMy, 'pRename');
		}
	}

	private saveOrders() {
		this.saveOrdersDC.send();
	}

	bEdit_click() {
		document.location = this.showLinkTemplate.replace('{id}', this.selectedNode.data.id.toString());
	}

	async bCopy_click(): Promise<any> {
		const parentId = this.getTargetId();
		const id = this.selectedNode.data.id;
		await this.cl.copyFilter(id, parentId);
		this.loadTree();
	}

	async bLink_click(): Promise<any> {
		const parentId = this.getTargetId();
		const id = this.selectedNode.data.id;
		await this.cl.linkFilter(id, parentId);
		this.loadTree();
	}

	getTargetId() {
		return this.targetNode.key.startsWith('root_')
			? null
			: this.targetNode.data.id;
	}
	async bMove_click() {
		const parentId = this.getTargetId();
		const id = this.selectedNode.data.id;
		if (this.selectedNode.data.type == "folder")
			await this.cl.moveFolder(id, parentId);
		else
			await this.cl.moveFilter(id, parentId);

		await this.loadTree();
	}

	async bRemove_click() {
		const id = this.selectedNode.data.id;
		if (!confirm(
			'Opravdu chcete smazat ' + (this.selectedNode.data.type == "folder" ? 'složku' : 'filtr')
			+ this.selectedNode.title
			+ (this.selectedNode.data.type == "folder" ? ' včetně podřízených složek a filtrů' : '')
			+ '?'
		)) return;
		if (this.selectedNode.data.type == "folder")
			await this.cl.deleteFolder(id);
		else
			await this.cl.deleteFilter(id);
		await this.loadTree();
	}

	async bSetPlace_click() {
		const id = this.selectedNode.data.id;
		await this.cl.setFolderPlace(id, this.ui.cPlace.value);
		await this.loadTree();
	}

	bAddFolder_click() {
		if (this.ui.cNewFolderName.value != '') {
			const parentFolderId = this.selectedNode
				? (this.selectedNode.data.type == 'folder'
					? this.selectedNode.data.id
					: (
						this.selectedNode.parent
						? this.selectedNode.parent.data.id
						: null
					)
				)
				: null;
			// alert("New folder in " + parentFolderId);
			this.cl.createFolder(this.ui.cNewFolderName.value, parentFolderId).then(() => this.loadTree());
		} else UiFlashMessage.instance.add('Zadejte název složky.');
	}

	async bRename_click() {
		if (this.selectedNode.data.type == 'folder')
			await this.cl.renameFolder(this.selectedNode.data.id, this.ui.cNewName.value);
		else
			await this.cl.renameFilter(this.selectedNode.data.id, this.ui.cNewName.value);

		await this.loadTree();
	}

	private getAllTreeNodes(): TreeNode[]
	{
		const res = [];
		if (!this.tree) return res;
		const addItems = (childs: TreeNode[]) => {
			for(let n of childs) {
				res.push(n);
				if (n.children) addItems(n.children);
			}
		}
		addItems(this.tree.getRootNode().children);
		return res;
	}

	private doSaveOders() {
		const ords = [];
		const addItems = (childs: TreeNode[]) => {
			let i = 0;
			for(let n of childs) {
				if (!n.data.isMy) continue;
				ords.push({
					id: n.data.id,
					type: n.data.type,
					numOrder: i++
				});
				if (n.children) addItems(n.children);
			}
		}
		addItems(this.tree.getRootNode().children);
		return this.cl.saveOrders(ords);
	}
}

export type TreeNode = {
	expanded: boolean,
	key: string,
	title: string,
	parent: TreeNode|null,
	children: TreeNode[],
	setExpanded(s: boolean),
	data: {
		place: string;
		type: "folder"|"filter",
		id: number,
		isMy: boolean
	}
};